/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Students_Title_LeadInputs */

const en_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Champions Mark has`)
};

const es_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campeones que Mark ha`)
};

const de_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Champions, die Mark`)
};

const zh_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark 培养的`)
};

const ar_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أبطال ساعد Mark`)
};

const fr_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les champions que Mark`)
};

const vi_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Những nhà vô địch Mark đã`)
};

const sw_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mabingwa ambao Mark`)
};

const th_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แชมป์ที่ Mark`)
};

const bs_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šampioni koje je Mark`)
};

const ja_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markが育てた`)
};

const ko_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark가 길러낸`)
};

const pt_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campeões que o Mark`)
};

const it_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campioni che Mark`)
};

const sv_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mästare som Mark`)
};

const nl_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampioenen die Mark heeft`)
};

const da_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mestre, som Mark`)
};

const nb_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mestere Mark har`)
};

const fi_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mestarit, joita Mark`)
};

const pl_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistrzowie, których`)
};

const ru_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чемпионы, которых`)
};

const tr_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark'ın yetişmesine`)
};

const hi_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark द्वारा तैयार`)
};

const id_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara yang`)
};

const ms_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara yang`)
};

const cs_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šampioni, které Mark`)
};

const el_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πρωταθλητές που`)
};

const he_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אלופים ש-Mark`)
};

const af_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampioene wat Mark`)
};

const hu_about_students_title_lead = /** @type {(inputs: About_Students_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bajnokok, akiket`)
};

/**
* | output |
* | --- |
* | "Champions Mark has" |
*
* @param {About_Students_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_students_title_lead = /** @type {((inputs?: About_Students_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Students_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_students_title_lead(inputs)
	if (locale === "de") return de_about_students_title_lead(inputs)
	if (locale === "zh") return zh_about_students_title_lead(inputs)
	if (locale === "ar") return ar_about_students_title_lead(inputs)
	if (locale === "fr") return fr_about_students_title_lead(inputs)
	if (locale === "vi") return vi_about_students_title_lead(inputs)
	if (locale === "sw") return sw_about_students_title_lead(inputs)
	if (locale === "th") return th_about_students_title_lead(inputs)
	if (locale === "bs") return bs_about_students_title_lead(inputs)
	if (locale === "ja") return ja_about_students_title_lead(inputs)
	if (locale === "ko") return ko_about_students_title_lead(inputs)
	if (locale === "pt") return pt_about_students_title_lead(inputs)
	if (locale === "it") return it_about_students_title_lead(inputs)
	if (locale === "sv") return sv_about_students_title_lead(inputs)
	if (locale === "nl") return nl_about_students_title_lead(inputs)
	if (locale === "da") return da_about_students_title_lead(inputs)
	if (locale === "nb") return nb_about_students_title_lead(inputs)
	if (locale === "fi") return fi_about_students_title_lead(inputs)
	if (locale === "pl") return pl_about_students_title_lead(inputs)
	if (locale === "ru") return ru_about_students_title_lead(inputs)
	if (locale === "tr") return tr_about_students_title_lead(inputs)
	if (locale === "hi") return hi_about_students_title_lead(inputs)
	if (locale === "id") return id_about_students_title_lead(inputs)
	if (locale === "ms") return ms_about_students_title_lead(inputs)
	if (locale === "cs") return cs_about_students_title_lead(inputs)
	if (locale === "el") return el_about_students_title_lead(inputs)
	if (locale === "he") return he_about_students_title_lead(inputs)
	if (locale === "af") return af_about_students_title_lead(inputs)
	if (locale === "hu") return hu_about_students_title_lead(inputs)
	return en_about_students_title_lead(inputs)
});